/* eslint-disable import/prefer-default-export */
import { GET_USER_GUIDE } from '../../types/Types';

export const userGuide = (data) => ({
  type: GET_USER_GUIDE,
  data,
});
